import { delay, put, takeLatest } from "redux-saga/effects";

import NavActionTypes from "./nav.types";
import { scrollToSection } from "./nav.actions";

function* clearSectionAfterScroll({ payload }) {
  // Ignore resets so we don't loop on the follow-up action.
  if (payload === null) return;

  yield delay(1000);
  yield put(scrollToSection(null));
}

function* onScrollToSection() {
  yield takeLatest(NavActionTypes.SCROLL_TO_SECTION, clearSectionAfterScroll);
}

export function* navSagas() {
  yield onScrollToSection();
}
